import type { FC } from "react";
import type { MatchStatsEntry as XpaMatchStatsEntry } from "@motain/xpa-proto-files-web/lib/types/match_stats";
import { MatchStatsEntry_Unit } from "@motain/xpa-proto-files-web/lib/types/match_stats";
import styles from "./MatchStatsEntry.module.scss";
import classNames from "classnames";

const HUNDRED_PERCENT = 100;
export const MatchStatsEntry: FC<XpaMatchStatsEntry> = (props) => {
  const { home, title, unit, away } = props;

  const progressBarMax =
    unit === MatchStatsEntry_Unit.ABSOLUTE ? home + away : HUNDRED_PERCENT;

  const percentage = unit === MatchStatsEntry_Unit.PERCENT && "%";

  return (
    <li className={styles.container}>
      <div className={styles.description}>
        <p className={classNames("title-7-medium", styles.homeValue)}>
          {home}
          {percentage}
        </p>
        <p className={classNames("title-8-regular", styles.title)}>{title}</p>
        <p className={classNames("title-7-medium", styles.awayValue)}>
          {away}
          {percentage}
        </p>
      </div>
      <progress
        className={classNames(
          home < away && styles.progressSmaller,
          styles.progress,
          styles.progressHome,
        )}
        max={progressBarMax}
        value={home}
      ></progress>
      <progress
        className={classNames(
          home > away && styles.progressSmaller,
          styles.progress,
        )}
        max={progressBarMax}
        value={away}
      ></progress>
    </li>
  );
};
